// extracted by mini-css-extract-plugin
export var card = "_od-0";
export var content = "_od-2";
export var details = "_od-3";
export var icon = "_od-1";
export var iconBlue = "_od-5";
export var iconBrand = "_od-4";
export var iconGrayBlue = "_od-6";
export var iconGreen = "_od-7";
export var iconIndigo = "_od-8";
export var iconOrange = "_od-9";
export var iconPurple = "_od-a";
export var iconRed = "_od-b";
export var iconWarning = "_od-c";